document.addEventListener('DOMContentLoaded', () => {
  // Respect user preferences for reduced motion
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  
  const observerOptions = {
    root: null,
    rootMargin: '0px 0px -15%', // Trigger when element is 15% into viewport for a heavier, premium feel
    threshold: 0.05
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Select all main sections on the homepage.
  // Exclude the first section (usually hero) so it loads instantly without animation delay.
  const sections = document.querySelectorAll('.template-index #site-main > .shopify-section:not(:first-child)');
  sections.forEach(sec => {
    // 1. Add staggered class to inner titles, text, and buttons to create layered animations
    const innerElements = sec.querySelectorAll('h2, .slogan-stats-number, .slogan-stats-text, .section-title, .title, p, .button, .btn, .dynamic-testimonial, .icon-block');
    let staggerCount = 0;
    innerElements.forEach(el => {
      // Limit stagger to top 4 elements to avoid excessive delays on long sections
      if (staggerCount < 4) {
        el.classList.add('stagger-el');
        staggerCount++;
      }
    });

    // 2. Observe the main section
    sec.classList.add('animate-on-scroll');
    observer.observe(sec);
  });
});
